import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { ChartOptions } from 'chart.js';
import { Label } from 'ng2-charts';
import { BehaviorSubject, Observable } from 'rxjs';
import { concatMap, first, map, share } from 'rxjs/operators';

import { filterTruthy } from '../../../../../utils/rxjs-operators/filter-truthy.operator';
import { generateCssColor } from '../../../../../utils/generate-css-color.func';
import { Refreshable } from '../../../../../utils/refreshable.interface';
import { DashboardService } from '../../dashboard.service';
import it from './i18n/active-sessions-categories.it.json';

@Component({
  selector: 'app-active-sessions-categories',
  templateUrl: './active-sessions-categories.component.html'
})
export class ActiveSessionsCategoriesComponent implements OnInit, Refreshable {

  private refresh$$ = new BehaviorSubject<void>(undefined);
  activeSessionsCategories$$ = this.refresh$$.pipe(
    concatMap(() => this.dashboardSvc.getActiveSessionsCategories().pipe(first())),
    share()
  );

  readonly options: ChartOptions = {
    responsive: true,
    legend: {
      position: 'top',
    },
    plugins: {
      datalabels: {
        formatter: (value: any, ctx: any) => {
          const label = ctx.chart.data.labels[ctx.dataIndex];
          return label;
        },
      },
    }
  };
  labels$: Observable<Label[]> = this.activeSessionsCategories$$.pipe(map(categories => categories.map(c => c.name), filterTruthy()));
  data$ = this.activeSessionsCategories$$.pipe(map(categories => categories.map(c => c.count), filterTruthy()));

  colors$ = this.activeSessionsCategories$$.pipe(
    map(categories => categories.map(() => generateCssColor())),
    map(colors => ([{ backgroundColor: colors, borderColor: 'transparent' }]))
  );

  constructor(
    private dashboardSvc: DashboardService,
    private translocoSvc: TranslocoService
  ) {
    this.translocoSvc.setTranslation(it, 'it');
  }

  ngOnInit() {
    this.refresh();
  }

  refresh() {
    this.refresh$$.next();
  }

}
